/**
 * Pure helpers that attach funnel-insights overlay metrics (and canvas-supplied
 * callbacks) onto ReactFlow node/edge `data`. Extracted from ReactFlowCanvas so
 * the editor canvas and the read-only analytics canvas (Spec D D1b) share one
 * code path — the editor's behavior is byte-identical to the pre-extraction
 * inline maps (AC-D1b-7).
 */
import type { Node, Edge } from '@xyflow/react';
import type { CanvasAnalyticsOverlay } from '@modules/reactFlow/types/flow-canvas-types';

export function withNodeAnalyticsData(
  node: Node,
  analyticsOverlay: CanvasAnalyticsOverlay | undefined,
  extraData: Record<string, unknown>,
): Node {
  return {
    ...node,
    data: {
      ...node.data,
      analyticsOverlay: analyticsOverlay?.nodesByScreenId[node.id],
      ...extraData,
    },
  };
}

export function withEdgeAnalyticsData(
  edge: Edge,
  analyticsOverlay: CanvasAnalyticsOverlay | undefined,
  extraData: Record<string, unknown>,
): Edge {
  return {
    ...edge,
    data: {
      ...edge.data,
      analyticsOverlay: analyticsOverlay?.edgesByTransitionId[edge.id],
      ...extraData,
    },
  };
}
